import type {
  JobRecommendationFragment,
  JobTeaserVisibleJobFragment,
} from '@xing-com/crate-jobs-graphql';
import { JobTeaserCard } from '@xing-com/crate-jobs-xinglets';

type JobRecommendationProps = { recommendation: JobRecommendationFragment };

export const Recommendation: React.FC<JobRecommendationProps> = ({
  recommendation,
}) => {
  const { job } = recommendation;
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const visibleJob = job as JobTeaserVisibleJobFragment;

  return (
    <JobTeaserCard
      job={visibleJob}
      url={visibleJob.url}
      matchingHighlights={recommendation.matchingHighlightsV2}
      headingLevel="h2"
      data-testid="job-recommendation-card"
      aria-label={visibleJob.title}
    />
  );
};
